"use strict";

const { hrtime, toMS } = require("./utils");

// Returns the DOMHighResTimeStamp representing the high resolution time value of the global monotonic clock.
function getGlobalMonotonicClockMS() {
  return toMS(hrtime());
}

module.exports = { getGlobalMonotonicClockMS };



//////////////////
// WEBPACK FOOTER
// ./node_modules/_w3c-hr-time@1.0.2@w3c-hr-time/lib/global-monotonic-clock.js
// module id = 5SRK
// module chunks = 0